import React from 'react';

const Quote = () => {
    return (
        <>
            <div className="p-4 mb-3 bg-dark rounded">
                <h4 className="fst-italic">Quote</h4>
                <p className="mb-0">When you have a dream, you've got to grab it and never let go.</p>
            </div>
        </>
    );
}

export default Quote;
